module.exports = __webpack_public_path__ + "img/bg-hen.89910754.png";